<div class="card table-container">
    <div class="row">
      <div class="col-12">
        <div *ngIf="showServiceCatalogTab" class="card" id="services_card_override">
          <div class="card-body text-center" id="services_header_card_body">  
            <ul class="d-none d-lg-flex  service-tab">
              <li  class="services-header" [ngClass]=" (optionSelected === myServiceTab) ? 'services-header-active' : '' "
                id="myservice_heading" (click)="onChangeServiceType(myServiceTab)">
                {{'ServicesList.myservices' | translate | uppercase }} ({{servicesCount}}) 
              </li>
              <li class="services-header" [ngClass]=" (optionSelected === serviceCatalogTab) ? 'services-header-active' : '' "
                id="myservice_heading" (click)="onChangeServiceType(serviceCatalogTab)">
                {{'ServicesList.serviceCatalog' | translate | uppercase }} ({{serviceCatalogCount}})
              </li>
            </ul>
            <div>
              <div class="services-dropdown d-lg-none" *ngIf="showServiceCatalogTab">
                <select  class="form-control custom-select" id="services_option_list"
                  (change)="onChangeServiceType($event.target.value)">
                  <option value="myservices"  [attr.selected]="optionSelected === myServiceTab ? true : null" >
                    {{ 'ServicesList.myservices' | translate | uppercase }}({{servicesCount}})
                  </option>
                  <option value="servicecatalog"  [attr.selected]="optionSelected === serviceCatalogTab ? true : null" >
                    {{ 'ServicesList.serviceCatalog' | translate | uppercase }} ({{serviceCatalogCount}})
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Service Item List Table -->
    <div class="service-container">
            <table class="" id="c_sitem_table">
                <!-- <thead> -->
                <tr id="c_sitem_table_header" class="cust-table-header">
                
                    <th (click)="sort('itemName')" style="flex: 0 0 100px;" id="itemName">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'itemName' && isDesc), 'fas fa-sort-up': (column == 'itemName' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'ServicesList.serviceName' | translate }}
                    </th>
                    <th (click)="sort('itemType')" style="flex: 0 0 100px;" id="itemType">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'itemType' && isDesc), 'fas fa-sort-up': (column == 'itemType' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'ServicesList.serviceType' | translate }}
                    </th>
                    <th style="flex: 0 0 100px;" id="itemIdentifier">
                        {{ 'ServicesList.serviceIdentifier' | translate }}
                    </th>
                    <th (click)="sort('statusType')" style="flex: 0 0 100px;" id="statusType">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'statusType' && isDesc), 'fas fa-sort-up': (column == 'statusType' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'ServicesList.serviceStatus' | translate }}
                    </th>
                    <th (click)="sort('sla')" style="flex: 0 0 100px;" id="sla">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'sla' && isDesc), 'fas fa-sort-up': (column == 'sla' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'ServicesList.serviceLevel' | translate }}
                    </th>
                
                </tr>
                <tbody *ngIf="isItemslist" appInfinteScroll (scrolledEnd)="scrollEnd()" (scrolledCur)="scrollCur()"> 
                  <tr *ngFor="let sitem of sitemsBasicInfoResponse; let i=index;trackBy: trackByItems"
                 id="c_sitem_table_body" (click)="getServiceItemDetail(sitem)">
                    <td>{{ sitem.itemName }}</td>
                    <td>{{ sitem.itemTypeName }}</td>
                    <td>{{ sitem.itemIdentifier }}</td>
                    <td>{{ sitem.itemStatus }}</td>
                    <td>{{ sitem.serviceLevel }}</td>
                </tr>
                </tbody>
                <!-- If no record found on global search -->
                <tbody *ngIf="(!isItemslist || sitemsBasicInfoResponse?.length === 0 ) && !isLoading && !spinnerStart">
                    <tr class="norecords">
                        <td colspan="5" class="text-center">{{ 'ItemsList.noRecords' | translate }}</td>
                    </tr>
                </tbody>
            </table>
       </div>
                <!-- Spinner -->
            <div class="text-center col-12" id="sd_store_item_loading ">
                    <div *ngIf="isLoading || spinnerStart" id="spinner" role="progressbar">
                        <zsd-spinner></zsd-spinner>
                    </div>
                </div>
            <!-- End of On Scroll Load Div -->
            <div *ngIf="scrollEndReached && sitemsBasicInfoResponse.length > 20" class="text-center" id="no_requests_message">
                <div class="card">
                <div class="card-body" id="sd_request_list_no_request_message">
                        {{ 'CommonStrings.endOfScroll' | translate }}
                    </div>
            </div>
            </div>
   </div>
